var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"500","cy":"500","r":"500","fill":"currentColor"}));
}

Circle.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000","fill":"none"};

module.exports = Circle;

Circle.default = Circle;
